module.exports = __webpack_public_path__ + "img/2025-10-15c_1.9045673e.jpg";